import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

export type PersonaKey =
  | 'millennial'
  | 'genx'
  | 'elder'
  | 'parent'
  | 'professional'
  | 'student';

type PersonaCtx = { persona: PersonaKey; setPersona: (p: PersonaKey) => void };
const Ctx = createContext<PersonaCtx | null>(null);
const KEY = 'backon.persona';
const DEFAULT: PersonaKey = 'millennial';

export const PersonaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [persona, setPersonaState] = useState<PersonaKey>(DEFAULT);
  useEffect(() => {
    try {
      const v = window.localStorage.getItem(KEY) as PersonaKey | null;
      if (v) setPersonaState(v);
    } catch {}
  }, []);
  const setPersona = (p: PersonaKey) => {
    setPersonaState(p);
    try {
      localStorage.setItem(KEY, p);
    } catch {}
  };
  const value = useMemo(() => ({ persona, setPersona }), [persona]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const usePersona = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('usePersona must be used within PersonaProvider');
  return ctx;
};
